module.exports = __webpack_public_path__ + "static/media/falcor.19b30040.jpg";